import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiStar,FiAward,FiHeart,FiGift,FiUsers,FiTrendingUp}=FiIcons;

const Home=()=> {
  const featuredImages=[
    'https://i.ibb.co/GvnMVSqM/Anni-Jewelry-images-1.jpg',
    'https://i.ibb.co/GfBC0Pcg/Anni-Jewelry-images-2.jpg',
    'https://i.ibb.co/C58185Tb/Anni-Jewelry-images-3.jpg',
    'https://i.ibb.co/0Vmyx6YY/Anni-Jewelry-images-4.jpg',
    'https://i.ibb.co/ymD5Cs9S/Anni-Jewelry-images-5.jpg',
    'https://i.ibb.co/HfJ35YZx/Anni-Jewelry-images-6.jpg'
  ];

  const features=[
    {icon: FiStar,title: 'Premium Quality',description: 'Handcrafted jewelry with the finest materials and attention to detail'},
    {icon: FiAward,title: 'Expert Craftsmanship',description: 'Over 20 years of experience in creating exquisite jewelry pieces'},
    {icon: FiHeart,title: 'Custom Designs',description: 'Personalized jewelry designed to celebrate your unique story'},
    {icon: FiGift,title: 'Special Occasions',description: 'Perfect pieces for engagements,weddings,and milestone celebrations'}
  ];

  const stats=[
    {icon: FiUsers,number: '5000+',label: 'Happy Customers'},
    {icon: FiAward,number: '20+',label: 'Years Experience'},
    {icon: FiStar,number: '4.9',label: 'Average Rating'},
    {icon: FiTrendingUp,number: '99%',label: 'Customer Satisfaction'}
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://i.ibb.co/ymMzKgZS/images.jpg" 
            alt="Luxury Jewelry" 
            className="w-full h-full object-cover"
            style={{
              imageRendering: '-webkit-optimize-contrast',
              transform: 'scale(1.05)',
              filter: 'brightness(0.7) contrast(1.1)'
            }}
          />
        </div>
        <div className="relative z-20 text-center max-w-4xl mx-auto px-4">
          <motion.h1
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            className="text-5xl md:text-7xl font-bold text-white mb-6 font-playfair text-shadow"
          >
            Exquisite <span className="text-gold">Jewelry</span>
          </motion.h1>
          <motion.p
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.2}}
            className="text-xl md:text-2xl text-gray-200 mb-8 max-w-2xl mx-auto"
          >
            Discover timeless elegance and exceptional craftsmanship at Anni Jewelry. Where every piece tells a story of love,beauty,and precious moments.
          </motion.p>
          <motion.div
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8,delay: 0.4}}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link to="/services" className="bg-gold text-black px-8 py-4 rounded-lg font-semibold text-lg hover:bg-yellow-400 transition-all duration-300 shadow-gold">
              Explore Collection
            </Link>
            <Link to="/contact" className="border-2 border-gold text-gold px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gold hover:text-black transition-all duration-300">
              Contact Us
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-playfair">
              Why Choose <span className="text-gold">Anni Jewelry</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              We combine traditional craftsmanship with modern design to create jewelry that captures the essence of your most precious moments.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.8,delay: index * 0.1}}
                viewport={{once: true}}
                className="text-center p-6 bg-black/50 rounded-lg border border-gold/20 hover:border-gold/50 transition-all duration-300"
              >
                <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-xl font-semibold text-gold mb-3">{feature.title}</h3>
                <p className="text-gray-300">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,scale: 0.5}}
                whileInView={{opacity: 1,scale: 1}}
                transition={{duration: 0.8,delay: index * 0.1}}
                viewport={{once: true}}
                className="text-center"
              >
                <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={stat.icon} className="w-8 h-8 text-black" />
                </div>
                <div className="text-3xl md:text-4xl font-bold text-gold mb-2">{stat.number}</div>
                <div className="text-gray-300">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Collection */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-playfair">
              Featured <span className="text-gold">Collection</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Explore our carefully curated collection of premium jewelry pieces,each crafted with precision and designed to make every moment special.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {featuredImages.map((image,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.8,delay: index * 0.1}}
                viewport={{once: true}}
                className="group cursor-pointer"
              >
                <div className="relative overflow-hidden rounded-lg bg-black/50 border border-gold/20 hover:border-gold/50 transition-all duration-300">
                  <img 
                    src={image} 
                    alt={`Jewelry Collection ${index + 1}`} 
                    className="w-full h-80 object-cover image-hover"
                    style={{
                      imageRendering: '-webkit-optimize-contrast'
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="absolute bottom-4 left-4 right-4">
                      <h3 className="text-white font-semibold text-lg mb-2">Premium Collection</h3>
                      <p className="text-gray-300 text-sm">Exquisite craftsmanship meets timeless design</p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          <motion.div
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="text-center mt-12"
          >
            <Link to="/services" className="inline-block bg-gold text-black px-8 py-4 rounded-lg font-semibold text-lg hover:bg-yellow-400 transition-all duration-300 shadow-gold">
              View Full Collection
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-16 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            viewport={{once: true}}
            className="text-center mb-12"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-playfair">
              What Our <span className="text-gold">Clients Say</span>
            </h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {name: "Sarah Johnson",text: "Absolutely stunning engagement ring! The quality and craftsmanship exceeded our expectations. Highly recommended!",rating: 5},
              {name: "Michael Chen",text: "Custom wedding bands turned out perfect. The team was professional and the attention to detail was remarkable.",rating: 5},
              {name: "Emma Wilson",text: "Beautiful necklace for my anniversary. The service was exceptional and the piece is absolutely gorgeous!",rating: 5}
            ].map((testimonial,index)=> (
              <motion.div
                key={index}
                initial={{opacity: 0,y: 30}}
                whileInView={{opacity: 1,y: 0}}
                transition={{duration: 0.8,delay: index * 0.1}}
                viewport={{once: true}}
                className="bg-gray-900 p-6 rounded-lg border border-gold/20"
              >
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_,i)=> (
                    <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-gold" />
                  ))}
                </div>
                <p className="text-gray-300 mb-4 italic">"{testimonial.text}"</p>
                <p className="text-gold font-semibold">- {testimonial.name}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;